module.exports = __webpack_public_path__ + "img/65655feb35edec8424f4729b407dab99.png";